import {
    TextField as SearchTextInput, makeStyles,
    Button, Switch, Chip
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: theme.spacing(0.5),
        margin: 0,
        width: '100%'
    },
    chip: {
        margin: theme.spacing(0.5),
    },
    table: {
        minWidth: 650,
    }
}));

const productType = [
    {
        value: 'NONE',
        label: 'همه انواع محصولات'
    },
    {
        value: 'MENTOR',
        label: 'حامی',
    },
    {
        value: 'DIET',
        label: 'رژیم',
    },
    {
        value: 'BUNDLE',
        label: 'باندل',
    },
    {
        value: 'PSYCHOLOGY_SESSION',
        label: 'روان‌شناسی',
    },
    {
        value: 'PARTNER_DISCOUNT',
        label: 'تخفیف همکار',
    },
    {
        value: 'TAG',
        label: 'دسته بندی',
    },
    {
        value: 'PRODUCT',
        label: 'عادی',
    },
];

export function ProductSearch({filterList, setFilterList}: any): React.ReactElement {
    const classes = useStyles();

    const handleDeleteTag = (chipToDelete: any) => () => {
        setFilterList({ ...filterList, tags: filterList.tags.filter((tag: any) => tag.key !== chipToDelete.key) })
    };

    const handleAddTag = (e: any, newTagLabel: any) => {
        let existTag = filterList.tags.some((t: any) => t?.key === newTagLabel.toUpperCase())
        if (!existTag && newTagLabel !== "")
            setFilterList({ ...filterList, tags: [...filterList.tags, { key: newTagLabel.toUpperCase(), label: newTagLabel }] })
    }

    return (
        <div className='search-panel' style={{ marginBottom: '2rem' }}>
            <p style={{ fontFamily: 'IranSans-Bold'}}>
                برای جستجو بین محصولات، فیلدهای زیر را پُر کنید:
            </p>        
            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', flexDirection: 'column', gap: '0.5rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0.5rem', width: '100%' }}>
                    <SearchTextInput
                        fullWidth
                        id="outlined-select-currency-native"
                        onChange={(e) => setFilterList({ ...filterList, id: { contains: e.target.value } })}
                        variant="outlined"
                        value={filterList.id.contains}
                        placeholder="Id"
                    >
                    </SearchTextInput>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                        <p className="text-IranSans-Bold">نمایش محصولات فعال</p>
                        <Switch                            
                            checked={filterList.isEnabled.equals}
                            onChange={(e: any) => setFilterList({ ...filterList, isEnabled: { equals: e.target.checked}}) }
                            color="primary"
                            name="checkedA"
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                        />
                    </div>                   
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0.5rem', width: '100%' }}>
                    <SearchTextInput
                        id="outlined-select-currency-native"
                        select
                        onChange={(e: any) => setFilterList({ ...filterList, productType: { equals: e.target.value}})}
                        variant="outlined"
                        fullWidth
                        placeholder='نوع محصول'
                        value={filterList.productType.equals}                   
                    >
                        {productType.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </SearchTextInput>
                    <SearchTextInput
                        fullWidth
                        id="outlined-select-currency-native"
                        onChange={(e) => setFilterList({ ...filterList, title: { contains: e.target.value } })}
                        variant="outlined"
                        value={filterList.title.contains}
                        placeholder="عنوان"
                    >
                    </SearchTextInput> 
                </div>
                <div style={{ display: 'flex', flexDirection: 'row-reverse', alignItems: 'center', marginBottom: '1rem', width: '100%' }}>
                    <div className={classes.root}>
                        {filterList.tags?.map((data: any) => {
                            return (
                                <li key={data.key}>
                                    <Chip                                       
                                        label={data.label}
                                        onDelete={handleDeleteTag(data)}                                    
                                        variant="outlined"
                                    />
                                </li>
                            );
                        })}

                    </div>
                    <SearchTextInput fullWidth onBlur={(e) => handleAddTag(e, e.target.value)} size="medium" label="تگ" variant="outlined"></SearchTextInput>
                </div>
            </div>
        </div>
    )
}